import React from 'react';
import { SvgIcon } from '@material-ui/core';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import { SubscriptionOutline as SubscriptionOutlineIcon } from '../../../components/Icons';

const subscriptionAppBarItemsList = [
  {
    name: 'My Account',
    href: '/account-settings',
    icon: <AccountCircleOutlinedIcon />,
  },
  {
    name: 'Billing',
    href: '/billing',
    icon: <ReceiptOutlinedIcon />,
  },
  {
    name: 'Subscriptions',
    href: '/subscriptions',
    icon: (
      <SvgIcon
        component={SubscriptionOutlineIcon}
        className="subscription-icon"
      />
    ),
  },
];

export default subscriptionAppBarItemsList.filter((n) => n);
